import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/45b021a8/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ResourceCard = makeShortcode("ResourceCard");
const MdxIcon = makeShortcode("MdxIcon");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`The repository structure was overhauled during the transition from v9 to v10. Carbon code now lives in a monorepo.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Repo architecture</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Carbon components</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Carbon elements</AnchorLink>
    </AnchorLinks>
    <h2>{`Repo architecture`}</h2>
    <p><a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon-themes"
      }}>{`Carbon-themes`}</a>{` was deprecated in v10, and the themes package `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon/tree/master/packages/themes"
      }}>{`@carbon/themes`}</a>{` now lives in the `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon"
      }}>{`Carbon`}</a>{` Carbon monorepo.`}</p>
    <Row className="resource-card-group" mdxType="Row">
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="@carbon/themes package" href="https://github.com/carbon-design-system/carbon/tree/master/packages/themes" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
    </Row>
    <h2>{`Carbon components`}</h2>
    <p>{`Carbon components were reskinned in v10. The redesign was conducted with maximum backwards-compatibility in mind. Users of v9 should be able to upgrade to v10 automatically with minimal breakage.`}</p>
    <p>{`Detailed technical migration docs for Carbon components are available in the `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon/blob/master/packages/components/docs/migration/migrate-to-10.x.md"
      }}>{`carbon-components repo`}</a>{`. Here you will find links to component-level migration information, as well as a list of those components that have been removed or are under development.`}</p>
    <p>{`There is also a dedicated `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon/blob/master/packages/components/src/globals/scss/migrate-to-10.x.md"
      }}>{`Sass migration guide`}</a>{` that covers changes to global styling.`}</p>
    <Row className="resource-card-group" mdxType="Row">
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="Migrate carbon-components" href="https://github.com/carbon-design-system/carbon/blob/master/packages/components/docs/migration/migrate-to-10.x.md" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="Migrate carbon-components-react" href="https://github.com/carbon-design-system/carbon/tree/master/packages/react/docs/migration" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="Migrate carbon-components Sass" href="https://github.com/carbon-design-system/carbon/blob/master/packages/components/src/globals/scss/migrate-to-10.x.md" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
    </Row>
    <h2>{`Carbon elements`}</h2>
    <p>{`All technical migration docs for Carbon elements are available in the `}<inlineCode parentName="p">{`carbon`}</inlineCode>{` monorepo `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon/tree/master/docs/migration"
      }}>{`docs folder`}</a>{`.`}</p>
    <Row className="resource-card-group" mdxType="Row">
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="Migrate elements" href="https://github.com/carbon-design-system/carbon/tree/master/docs/migration" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
    </Row>
    <h3>{`Icons`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`@carbon/icons`}</inlineCode>{` package can be now be found in the `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon/tree/master/packages/icons"
      }}>{`Carbon monorepo`}</a>{`.`}</p>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://carbon-elements.netlify.com/icons/examples/preview/"
      }}>{`Carbon icons demo`}</a>{` contains a master table for all Carbon icons, including name, size, preview, download links, quick links for filing issues, module name, and relative path.`}</p>
    <Row className="resource-card-group" mdxType="Row">
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="Carbon icon package" href="https://github.com/carbon-design-system/carbon/blob/master/packages/components/docs/migration/migrate-to-10.x.md" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="Migrate icons" href="https://github.com/carbon-design-system/carbon/blob/master/docs/migration/10.x-icons.md" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="Icon demo" href="https://carbon-elements.netlify.com/icons/examples/preview/" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
    </Row>
    <h3>{`Color`}</h3>
    <p>{`The v10 color token architecture is based on the v9 architecture, with some minor changes to align with the design language. Carbon v9 product teams will see automatic, non-breaking color updates when they upgrade to v10.`}</p>
    <Row className="resource-card-group" mdxType="Row">
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="Migrate color" href="https://github.com/carbon-design-system/carbon/blob/master/docs/migration/10.x-color.md" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="Primary token-value mapping" href="https://carbon-elements.netlify.com/colors/examples/preview/" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="Themes token-value mapping" href="https://carbon-elements.netlify.com/themes/examples/preview/" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
    </Row>
    <h3>{`Type`}</h3>
    <p>{`The type token architecture was redesigned for better clarity and flexibility. V10 moves from a basic type scale model to a more robust token-based architecture.`}</p>
    <Row className="resource-card-group" mdxType="Row">
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="Migrate type" href="https://github.com/carbon-design-system/carbon/blob/master/docs/migration/10.x-type.md" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="Type styles demo" href="https://carbon-elements.netlify.com/type/examples/preview/" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
    </Row>
    <h3>{`Layout, grid, and spacing`}</h3>
    <p>{`Token names changed in v10 but spacing values did not.`}</p>
    <Row className="resource-card-group" mdxType="Row">
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="Migrate the grid" href="https://github.com/carbon-design-system/carbon/blob/master/packages/components/src/globals/grid/migrate-to-10.x.md" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="Migrate layout" href="https://github.com/carbon-design-system/carbon/blob/master/docs/migration/10.x-layout.md" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="Interactive grid examples" href="https://carbon-elements.netlify.com/grid/examples/preview/" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
    </Row>
    <h3>{`Motion`}</h3>
    <p>{`Carbon adheres to IBM Design Language motion standards. Motion updates should be coordinated with your product’s design team.`}</p>
    <Row className="resource-card-group" mdxType="Row">
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="IBM motion package" href="https://github.com/carbon-design-system/carbon/tree/master/packages/motion" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="Migrate motion" href="https://github.com/carbon-design-system/carbon/blob/master/docs/migration/10.x-motion.md" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      